import clsx from 'clsx'
import type { PropsWithChildren, ReactNode } from 'react'

import s from './Panel.module.css'

interface PanelProps extends PropsWithChildren {
  title?: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  className?: string
  bodyClassName?: string
  /** Без внутренних отступов у тела — для списков и таблиц во всю ширину. */
  flush?: boolean
}

export function Panel({
  title,
  subtitle,
  actions,
  children,
  className,
  bodyClassName,
  flush,
}: PanelProps) {
  const hasHeader = Boolean(title || subtitle || actions)
  return (
    <section className={clsx(s.panel, className)}>
      {hasHeader && (
        <header className={s.header}>
          {title && <h3 className={s.title}>{title}</h3>}
          {(subtitle || actions) && (
            <div className={s.aside}>
              {subtitle && <span className={s.subtitle}>{subtitle}</span>}
              {actions}
            </div>
          )}
        </header>
      )}
      <div className={clsx(!flush && s.body, bodyClassName)}>{children}</div>
    </section>
  )
}
